export default __webpack_public_path__ + "static/media/welcome_backdrop.bc25379f.png";